import { Injectable } from '@angular/core';
import {
  ActiveLookup,
  AGENCY_TYPE,
  AgencyKeys,
  CarrierModelKeys,
  LookupKeys,
  Lookups,
} from '@ag-common-lib/public-api';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AgencyService, CarrierService } from '../../public-api';
import { BaseModelKeys } from '@ag-common-lib/lib/models/base.model';

@Injectable({ providedIn: 'root' })
export class LookupsFromDataService {
  // Lookups from data
  readonly carriersLookup$: Observable<Partial<ActiveLookup>[]>;
  readonly mgaLookup$: Observable<Partial<ActiveLookup>[]>;
  readonly agencyLookup$: Observable<Partial<ActiveLookup>[]>;

  constructor(carriersService: CarrierService, agencyService: AgencyService) {
    this.carriersLookup$ = carriersService.getList().pipe(
      map(carriers => {
        return carriers?.map((carrier): Partial<ActiveLookup> => {
          return {
            [BaseModelKeys.dbId]: carrier?.[BaseModelKeys.dbId],
            [LookupKeys.value]: carrier?.[BaseModelKeys.dbId],
            [LookupKeys.description]: carrier?.[CarrierModelKeys.carrierName],
          };
        });
      }),
    );

    this.mgaLookup$ = agencyService.getList().pipe(
      map(agencies => {
        return agencies
          ?.filter(agency => agency?.[AgencyKeys.agencyType] == AGENCY_TYPE.MGA)
          ?.map((agency): Partial<ActiveLookup> => {
            return {
              [BaseModelKeys.dbId]: agency?.[BaseModelKeys.dbId],
              [LookupKeys.value]: agency?.[AgencyKeys.agencyId],
              [LookupKeys.description]: agency?.[AgencyKeys.name],
            };
          });
      }),
    );

    this.agencyLookup$ = agencyService.getList().pipe(
      map(agencies => {
        return agencies?.map((agency): Partial<ActiveLookup> => {
          return {
            [BaseModelKeys.dbId]: agency?.[BaseModelKeys.dbId],
            [LookupKeys.value]: agency?.[AgencyKeys.agencyId],
            [LookupKeys.description]: agency?.[AgencyKeys.name],
          };
        });
      }),
    );
  }

  public getLookupByName = (lookup: Lookups): Observable<Partial<ActiveLookup>[]> => {
    switch (lookup) {
      // Lookups from data
      case Lookups.Carriers:
        return this.carriersLookup$;
      case Lookups.MGA:
        return this.mgaLookup$;
      case Lookups.Agency:
        return this.agencyLookup$;
      default:
        return of([]);
    }
  };
}
